import { render, staticRenderFns } from "./TgpItem.vue?vue&type=template&id=b669786c"
import script from "./TgpItem.vue?vue&type=script&lang=js"
export * from "./TgpItem.vue?vue&type=script&lang=js"
import style0 from "./TgpItem.vue?vue&type=style&index=0&id=b669786c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports